module.exports = __webpack_public_path__ + "static/media/Planilha.b1886811.svg";